/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Checkout_Create_Delivery_ErrorInputs */

const vi_pos_checkout_create_delivery_error = /** @type {(inputs: Pos_Checkout_Create_Delivery_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn giao thất bại`)
};

/**

* @param {Pos_Checkout_Create_Delivery_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_checkout_create_delivery_error = /** @type {((inputs?: Pos_Checkout_Create_Delivery_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Checkout_Create_Delivery_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_checkout_create_delivery_error(inputs)
});